export const countryCodes = [
  { value: '', label: 'None' },
  { value: 'Afghanistan', label: 'AF - Afghanistan' },
  { value: 'Åland Islands', label: 'AX - Åland Islands' },
  { value: 'Albania', label: 'AL - Albania' },
  { value: 'Algeria', label: 'DZ - Algeria' },
  { value: 'American Samoa', label: 'AS - American Samoa' },
  { value: 'Andorra', label: 'AD - Andorra' },
  { value: 'Angola', label: 'AO - Angola' },
  { value: 'Anguilla', label: 'AI - Anguilla' },
  { value: 'Antarctica', label: 'AQ - Antarctica' },
  { value: 'Antigua and Barbuda', label: 'AG - Antigua and Barbuda' },
  { value: 'Argentina', label: 'AR - Argentina' },
  { value: 'Armenia', label: 'AM - Armenia' },
  { value: 'Aruba', label: 'AW - Aruba' },
  { value: 'Australia', label: 'AU - Australia' },
  { value: 'Austria', label: 'AT - Austria' },
  { value: 'Azerbaijan', label: 'AZ - Azerbaijan' },
  { value: 'Bahamas', label: 'BS - Bahamas' },
  { value: 'Bahrain', label: 'BH - Bahrain' },
  { value: 'Bangladesh', label: 'BD - Bangladesh' },
  { value: 'Barbados', label: 'BB - Barbados' },
  { value: 'Belarus', label: 'BY - Belarus' },
  { value: 'Belgium', label: 'BE - Belgium' },
  { value: 'Belize', label: 'BZ - Belize' },
  { value: 'Benin', label: 'BJ - Benin' },
  { value: 'Bermuda', label: 'BM - Bermuda' },
  { value: 'Bhutan', label: 'BT - Bhutan' },
  { value: 'Bolivia', label: 'BO - Bolivia' },
  { value: 'Bosnia and Herzegovina', label: 'BA - Bosnia and Herzegovina' },
  { value: 'Botswana', label: 'BW - Botswana' },
  { value: 'Bouvet Island', label: 'BV - Bouvet Island' },
  { value: 'Brazil', label: 'BR - Brazil' },
  {
    value: 'British Indian Ocean Territory',
    label: 'IO - British Indian Ocean Territory',
  },
  { value: 'Brunei Darussalam', label: 'BN - Brunei Darussalam' },
  { value: 'Bulgaria', label: 'BG - Bulgaria' },
  { value: 'Burkina Faso', label: 'BF - Burkina Faso' },
  { value: 'Burundi', label: 'BI - Burundi' },
  { value: 'Cambodia', label: 'KH - Cambodia' },
  { value: 'Cameroon', label: 'CM - Cameroon' },
  { value: 'Canada', label: 'CA - Canada' },
  { value: 'Cape Verde', label: 'CV - Cape Verde' },
  { value: 'Cayman Islands', label: 'KY - Cayman Islands' },
  { value: 'Central African Republic', label: 'CF - Central African Republic' },
  { value: 'Chad', label: 'TD - Chad' },
  { value: 'Chile', label: 'CL - Chile' },
  { value: 'China', label: 'CN - China' },
  { value: 'Christmas Island', label: 'CX - Christmas Island' },
  { value: 'Cocos (Keeling) Islands', label: 'CC - Cocos (Keeling) Islands' },
  { value: 'Colombia', label: 'CO - Colombia' },
  { value: 'Comoros', label: 'KM - Comoros' },
  { value: 'Congo', label: 'CG - Congo' },
  {
    value: 'Congo, The Democratic Republic of the',
    label: 'CD - Congo, The Democratic Republic of the',
  },
  { value: 'Cook Islands', label: 'CK - Cook Islands' },
  { value: 'Costa Rica', label: 'CR - Costa Rica' },
  { value: 'Croatia', label: 'HR - Croatia' },
  { value: 'Cuba', label: 'CU - Cuba' },
  { value: 'Cyprus', label: 'CY - Cyprus' },
  { value: 'Czech Republic', label: 'CZ - Czech Republic' },
  { value: 'Denmark', label: 'DK - Denmark' },
  { value: 'Djibouti', label: 'DJ - Djibouti' },
  { value: 'Dominica', label: 'DM - Dominica' },
  { value: 'Dominican Republic', label: 'DO - Dominican Republic' },
  { value: 'Ecuador', label: 'EC - Ecuador' },
  { value: 'Egypt', label: 'EG - Egypt' },
  { value: 'El Salvador', label: 'SV - El Salvador' },
  { value: 'Equatorial Guinea', label: 'GQ - Equatorial Guinea' },
  { value: 'Eritrea', label: 'ER - Eritrea' },
  { value: 'Estonia', label: 'EE - Estonia' },
  { value: 'Ethiopia', label: 'ET - Ethiopia' },
  { value: 'Falkland Islands (Malvinas)', label: 'FK - Falkland Islands' },
  { value: 'Faroe Islands', label: 'FO - Faroe Islands' },
  { value: 'Fiji', label: 'FJ - Fiji' },
  { value: 'Finland', label: 'FI - Finland' },
  { value: 'France', label: 'FR - France' },
  { value: 'French Guiana', label: 'GF - French Guiana' },
  { value: 'French Polynesia', label: 'PF - French Polynesia' },
  {
    value: 'French Southern Territories',
    label: 'TF - French Southern Territories',
  },
  { value: 'Gabon', label: 'GA - Gabon' },
  { value: 'Gambia', label: 'GM - Gambia' },
  { value: 'Georgia', label: 'GE - Georgia' },
  { value: 'Germany', label: 'DE - Germany' },
  { value: 'Ghana', label: 'GH - Ghana' },
  { value: 'Gibraltar', label: 'GI - Gibraltar' },
  { value: 'Greece', label: 'GR - Greece' },
  { value: 'Greenland', label: 'GL - Greenland' },
  { value: 'Grenada', label: 'GD - Grenada' },
  { value: 'Guadeloupe', label: 'GP - Guadeloupe' },
  { value: 'Guam', label: 'GU - Guam' },
  { value: 'Guatemala', label: 'GT - Guatemala' },
  { value: 'Guernsey', label: 'GG - Guernsey' },
  { value: 'Guinea', label: 'GN - Guinea' },
  { value: 'Guinea-Bissau', label: 'GW - Guinea-Bissau' },
  { value: 'Guyana', label: 'GY - Guyana' },
  { value: 'Haiti', label: 'HT - Haiti' },
  {
    value: 'Heard Island and Mcdonald Islands',
    label: 'HM - Heard Island and Mcdonald Islands',
  },
  { value: 'Holy See (Vatican City State)', label: 'VA - Vatican City' },
  { value: 'Honduras', label: 'HN - Honduras' },
  { value: 'Hungary', label: 'HU - Hungary' },
  { value: 'Iceland', label: 'IS - Iceland' },
  { value: 'India', label: 'IN - India' },
  { value: 'Indonesia', label: 'ID - Indonesia' },
  { value: 'Iran', label: 'IR - Iran' },
  { value: 'Iraq', label: 'IQ - Iraq' },
  { value: 'Ireland', label: 'IE - Ireland' },
  { value: 'Isle of Man', label: 'IM - Isle of Man' },
  { value: 'Israel', label: 'IL - Israel' },
  { value: 'Italy', label: 'IT - Italy' },
  { value: 'Jamaica', label: 'JM - Jamaica' },
  { value: 'Japan', label: 'JP - Japan' },
  { value: 'Jersey', label: 'JE - Jersey' },
  { value: 'Jordan', label: 'JO - Jordan' },
  { value: 'Kazakhstan', label: 'KZ - Kazakhstan' },
  { value: 'Kenya', label: 'KE - Kenya' },
  { value: 'Kiribati', label: 'KI - Kiribati' },
  { value: 'Korea', label: 'KR - Korea' },
  { value: 'Kosovo', label: 'KV - Kosovo' },
  { value: 'Kuwait', label: 'KW - Kuwait' },
  { value: 'Kyrgyzstan', label: 'KG - Kyrgyzstan' },
  { value: 'Latvia', label: 'LV - Latvia' },
  { value: 'Lebanon', label: 'LB - Lebanon' },
  { value: 'Lesotho', label: 'LS - Lesotho' },
  { value: 'Liberia', label: 'LR - Liberia' },
  { value: 'Libyan Arab Jamahiriya', label: 'LY - Libyan Arab Jamahiriya' },
  { value: 'Liechtenstein', label: 'LI - Liechtenstein' },
  { value: 'Lithuania', label: 'LT - Lithuania' },
  { value: 'Luxembourg', label: 'LU - Luxembourg' },
  { value: 'Macao', label: 'MO - Macao' },
  { value: 'Macedonia', label: 'MK - Macedonia' },
  { value: 'Madagascar', label: 'MG - Madagascar' },
  { value: 'Malawi', label: 'MW - Malawi' },
  { value: 'Malaysia', label: 'MY - Malaysia' },
  { value: 'Maldives', label: 'MV - Maldives' },
  { value: 'Mali', label: 'ML - Mali' },
  { value: 'Malta', label: 'MT - Malta' },
  { value: 'Marshall Islands', label: 'MH - Marshall Islands' },
  { value: 'Martinique', label: 'MQ - Martinique' },
  { value: 'Mauritania', label: 'MR - Mauritania' },
  { value: 'Mauritius', label: 'MU - Mauritius' },
  { value: 'Mayotte', label: 'YT - Mayotte' },
  { value: 'Mexico', label: 'MX - Mexico' },
  { value: 'Micronesia', label: 'FM - Micronesia' },
  { value: 'Moldova', label: 'MD - Moldova' },
  { value: 'Monaco', label: 'MC - Monaco' },
  { value: 'Mongolia', label: 'MN - Mongolia' },
  { value: 'Montserrat', label: 'MS - Montserrat' },
  { value: 'Morocco', label: 'MA - Morocco' },
  { value: 'Mozambique', label: 'MZ - Mozambique' },
  { value: 'Myanmar', label: 'MM - Myanmar' },
  { value: 'Namibia', label: 'NA - Namibia' },
  { value: 'Nauru', label: 'NR - Nauru' },
  { value: 'Nepal', label: 'NP - Nepal' },
  { value: 'Netherlands', label: 'NL - Netherlands' },
  { value: 'Netherlands Antilles', label: 'AN - Netherlands Antilles' },
  { value: 'New Caledonia', label: 'NC - New Caledonia' },
  { value: 'New Zealand', label: 'NZ - New Zealand' },
  { value: 'Nicaragua', label: 'NI - Nicaragua' },
  { value: 'Niger', label: 'NE - Niger' },
  { value: 'Nigeria', label: 'NG - Nigeria' },
  { value: 'Niue', label: 'NU - Niue' },
  { value: 'Norfolk Island', label: 'NF - Norfolk Island' },
  { value: 'Northern Mariana Islands', label: 'MP - Northern Mariana Islands' },
  { value: 'Norway', label: 'NO - Norway' },
  { value: 'Oman', label: 'OM - Oman' },
  { value: 'Pakistan', label: 'PK - Pakistan' },
  { value: 'Palau', label: 'PW - Palau' },
  { value: 'Palestinian Territory', label: 'PS - Palestinian Territory' },
  { value: 'Panama', label: 'PA - Panama' },
  { value: 'Papua New Guinea', label: 'PG - Papua New Guinea' },
  { value: 'Paraguay', label: 'PY - Paraguay' },
  { value: 'Peru', label: 'PE - Peru' },
  { value: 'Philippines', label: 'PH - Philippines' },
  { value: 'Pitcairn', label: 'PN - Pitcairn' },
  { value: 'Poland', label: 'PL - Poland' },
  { value: 'Portugal', label: 'PT - Portugal' },
  { value: 'Puerto Rico', label: 'PR - Puerto Rico' },
  { value: 'Qatar', label: 'QA - Qatar' },
  { value: 'Reunion', label: 'RE - Reunion' },
  { value: 'Romania', label: 'RO - Romania' },
  { value: 'Russia', label: 'RU - Russia' },
  { value: 'Rwanda', label: 'RW - Rwanda' },
  { value: 'Saint Helena', label: 'SH - Saint Helena' },
  { value: 'Saint Kitts and Nevis', label: 'KN - Saint Kitts and Nevis' },
  { value: 'Saint Lucia', label: 'LC - Saint Lucia' },
  {
    value: 'Saint Pierre and Miquelon',
    label: 'PM - Saint Pierre and Miquelon',
  },
  {
    value: 'Saint Vincent and the Grenadines',
    label: 'VC - Saint Vincent and the Grenadines',
  },
  { value: 'Samoa', label: 'WS - Samoa' },
  { value: 'San Marino', label: 'SM - San Marino' },
  { value: 'Sao Tome and Principe', label: 'ST - Sao Tome and Principe' },
  { value: 'Saudi Arabia', label: 'SA - Saudi Arabia' },
  { value: 'Senegal', label: 'SN - Senegal' },
  { value: 'Serbia and Montenegro', label: 'CS - Serbia and Montenegro' },
  { value: 'Seychelles', label: 'SC - Seychelles' },
  { value: 'Sierra Leone', label: 'SL - Sierra Leone' },
  { value: 'Singapore', label: 'SG - Singapore' },
  { value: 'Slovakia', label: 'SK - Slovakia' },
  { value: 'Slovenia', label: 'SI - Slovenia' },
  { value: 'Solomon Islands', label: 'SB - Solomon Islands' },
  { value: 'Somalia', label: 'SO - Somalia' },
  { value: 'South Africa', label: 'ZA - South Africa' },
  {
    value: 'South Georgia and the South Sandwich Islands',
    label: 'GS - South Georgia and the South Sandwich Islands',
  },
  { value: 'Spain', label: 'ES - Spain' },
  { value: 'Sri Lanka', label: 'LK - Sri Lanka' },
  { value: 'Sudan', label: 'SD - Sudan' },
  { value: 'Surivalue', label: 'SR - Surivalue' },
  { value: 'Svalbard and Jan Mayen', label: 'SJ - Svalbard and Jan Mayen' },
  { value: 'Swaziland', label: 'SZ - Swaziland' },
  { value: 'Sweden', label: 'SE - Sweden' },
  { value: 'Switzerland', label: 'CH - Switzerland' },
  { value: 'Syrian Arab Republic', label: 'SY - Syrian Arab Republic' },
  { value: 'Taiwan', label: 'TW - Taiwan' },
  { value: 'Tajikistan', label: 'TJ - Tajikistan' },
  { value: 'Tanzania', label: 'TZ - Tanzania' },
  { value: 'Thailand', label: 'TH - Thailand' },
  { value: 'Timor-Leste', label: 'TL - Timor-Leste' },
  { value: 'Togo', label: 'TG - Togo' },
  { value: 'Tokelau', label: 'TK - Tokelau' },
  { value: 'Tonga', label: 'TO - Tonga' },
  { value: 'Trinidad and Tobago', label: 'TT - Trinidad and Tobago' },
  { value: 'Tunisia', label: 'TN - Tunisia' },
  { value: 'Turkey', label: 'TR - Turkey' },
  { value: 'Turkmenistan', label: 'TM - Turkmenistan' },
  { value: 'Turks and Caicos Islands', label: 'TC - Turks and Caicos Islands' },
  { value: 'Tuvalu', label: 'TV - Tuvalu' },
  { value: 'Uganda', label: 'UG - Uganda' },
  { value: 'Ukraine', label: 'UA - Ukraine' },
  { value: 'United Arab Emirates', label: 'AE - United Arab Emirates' },
  { value: 'United Kingdom', label: 'GB - United Kingdom' },
  { value: 'United States', label: 'US - United States' },
  {
    value: 'United States Minor Outlying Islands',
    label: 'UM - United States Minor Outlying Islands',
  },
  { value: 'Uruguay', label: 'UY - Uruguay' },
  { value: 'Uzbekistan', label: 'UZ - Uzbekistan' },
  { value: 'Vanuatu', label: 'VU - Vanuatu' },
  { value: 'Venezuela', label: 'VE - Venezuela' },
  { value: 'Viet Nam', label: 'VN - Viet Nam' },
  { value: 'Virgin Islands, British', label: 'VG - Virgin Islands, British' },
  { value: 'Virgin Islands, U.S.', label: 'VI - Virgin Islands, U.S.' },
  { value: 'Wallis and Futuna', label: 'WF - Wallis and Futuna' },
  { value: 'Western Sahara', label: 'EH - Western Sahara' },
  { value: 'Yemen', label: 'YE - Yemen' },
  { value: 'Zambia', label: 'ZM - Zambia' },
  { value: 'Zimbabw', label: 'ZN - Zimbabw' },
];
